import {
  addCircularElement,
  moveCircularElement,
  previewAddCircularElement,
  previewMoveCircularElement
} from "./circularElementDomainFunctions";
import {addDrainage, moveDrainage, removeDrainage} from "../../features/floor/floorSlice";
import {getBevelWidth} from "./floor";

export const createFloorDomainFunctions = (dispatch, width, height) => {
  return {
    drainageFunctions: {
      previewAdd: item => previewAddCircularElement(width, height, item, getBevelWidth()),
      add: item => addCircularElement(
        item => dispatch(addDrainage({ drainage: item })),
        width,
        height,
        item,
        getBevelWidth()
      ),
      previewMove: item => previewMoveCircularElement(width, height, item, getBevelWidth()),
      move: item => moveCircularElement(
        (id, x, y) => dispatch(moveDrainage({id, x, y})),
        width,
        height,
        item,
        getBevelWidth()
      ),
      remove: id => dispatch(removeDrainage({id}))
    }
  }
}
